import { FC, useMemo } from 'react';

import { BarChart } from '@/components/charts/bar-chart';
import ModelLegend from '@/components/charts/model-legend';
import type { BarChartClickHandler } from '@/components/charts/types';
import { Card } from '@/components/ui/card';
import type { ChartData } from '@/routes/(app)/(clusters)/lib/types';

interface ClusterChartProps {
  title: string;
  description: string;
  xAxis: string;
  data: Array<ChartData>;
  onClick: BarChartClickHandler;
}

export const ClusterChart: FC<ClusterChartProps> = ({
  title,
  description,
  xAxis,
  data,
  onClick,
}) => {
  const orderedData = useMemo(() => {
    const sorter = (chartA: ChartData, chartB: ChartData) => {
      const aValue = chartA[xAxis as keyof typeof chartA];
      const bValue = chartB[xAxis as keyof typeof chartB];
      return Number(bValue) - Number(aValue);
    };
    return data.sort(sorter).slice(0, 5);
  }, [data, xAxis]);

  return (
    <Card className='px-6'>
      <BarChart
        title={title}
        description={description}
        xAxis={xAxis}
        data={orderedData}
        handleClick={onClick}>
        <BarChart.Legend>
          <ModelLegend data={orderedData} />
        </BarChart.Legend>
      </BarChart>
    </Card>
  );
};
